import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { QuickSummaryButtonPlaceholder } from '../src/QuickSummaryButtonPlaceholder';

export const QuickSummaryPopup = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickSummaryPopup" */ '../src/QuickSummaryPopup'))
			.QuickSummaryPopup,
	loading: ({ buttonStyles }) => <QuickSummaryButtonPlaceholder buttonStyles={buttonStyles} />,
});
